import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const usePanelOpenAnalyticsEvents = (isContentCreationPanelShown, contentId): void => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const hasScreenEventFired = useRef(false);

	useEffect(() => {
		if (!hasScreenEventFired.current && isContentCreationPanelShown) {
			createAnalyticsEvent({
				type: 'sendScreenEvent',
				data: {
					name: 'templateDrawer',
					objectId: contentId,
				},
			}).fire();
			hasScreenEventFired.current = true;
		}

		// dont fire a close event until its been opened before
		if (hasScreenEventFired.current) {
			createAnalyticsEvent({
				type: 'sendTrackEvent',
				data: {
					source: 'templateDrawer',
					action: isContentCreationPanelShown ? 'opened' : 'closed',
					actionSubject: 'templateDrawer',
					objectId: contentId,
					actionSubjectId: isContentCreationPanelShown
						? 'templateDrawerOpened'
						: 'templateDrawerClosed',
				},
			}).fire();
		}
	}, [isContentCreationPanelShown, createAnalyticsEvent, contentId]);
};
